import { render } from "./FormIndexPage.vue?vue&type=template&id=2f8ad0fc&scoped=true"
import script from "./FormIndexPage.vue?vue&type=script&lang=js"
export * from "./FormIndexPage.vue?vue&type=script&lang=js"

import "./FormIndexPage.vue?vue&type=style&index=0&id=2f8ad0fc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f8ad0fc"]])

export default __exports__